import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-sales-price',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map